import React, { useState } from 'react';
import { writeText } from '../../../shared/utils/clipboard';

export const ReferralProgram = ({ user, t, trialSettings, referralBonusPercentage = 20 }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await writeText(user.referral_url);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleShare = async () => {
    try {
      await writeText(user.referral_url);
      alert(t('dashboard.index.referral.share_success'));
    } catch (err) {
      console.error('Failed to copy:', err);
      alert(t('dashboard.index.referral.share_error'));
    }
  };

  return (
    <div className="card border-0 rounded-3 mb-4 text-white" style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}>
      <div className="card-body p-4">
        <div className="text-center mb-3">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '48px', height: '48px', backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
            <i className="bi bi-gift" style={{ fontSize: '20px' }}></i>
          </div>
          <h3 className="h6 fw-bold mb-2">{t('dashboard.index.referral.title', { percentage: referralBonusPercentage })}</h3>
          <p className="small mb-0 opacity-90">{t('dashboard.index.referral.description')}</p>
        </div>

        <div className="rounded-2 p-3 mb-3" style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
          <label className="small fw-medium opacity-80 mb-2">{t('dashboard.index.referral.your_link')}</label>
          <div className="input-group flex-nowrap">
            <input
              type="text"
              className="form-control border-0"
              value={user.referral_url}
              readOnly
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', color: 'white', fontSize: '14px', minWidth: 0 }}
              data-referral-link-target="input"
            />
            <button
              className="btn border-0"
              type="button"
              onClick={handleCopy}
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', color: 'white', flexShrink: 0, width: 'auto' }}
              data-referral-link-target="copyButton"
              data-action="click->referral-link#copy"
            >
              <i className={copied ? 'bi bi-check-lg' : 'bi bi-clipboard'}></i>
            </button>
          </div>
        </div>

        <div className="d-flex flex-column gap-2 mb-3 small">
          <div className="d-flex align-items-center">
            <i className="bi bi-check-lg me-2"></i>
            <span>{t('dashboard.index.referral.benefit_1', { percentage: referralBonusPercentage })}</span>
          </div>
          <div className="d-flex align-items-center">
            <i className="bi bi-check-lg me-2"></i>
            <span>{t('dashboard.index.referral.benefit_2')}</span>
          </div>
          <div className="d-flex align-items-center">
            <i className="bi bi-check-lg me-2"></i>
            <span>{t('dashboard.index.referral.benefit_3')}</span>
          </div>
          {trialSettings?.has_trial_benefit && (
            <div className="d-flex align-items-center">
              <i className="bi bi-check-lg me-2"></i>
              <span>{t('dashboard.index.referral.benefit_4', {
                extra_days: trialSettings.extra_trial_days
              })}</span>
            </div>
          )}
        </div>

        <button
          className="btn btn-light w-100 fw-medium"
          style={{ borderRadius: '8px', color: '#059669' }}
          onClick={handleShare}
          data-action="click->referral-link#share"
        >
          <i className="bi bi-share me-2"></i>
          {t('dashboard.index.referral.share_now')}
        </button>
      </div>
    </div>
  );
};
